export default "Estimez vos primes CEE sur le patrimoine public (mairie, EPCI, bailleur social). Résultat chiffré par bâtiment en 60 secondes.";

